import React, {useEffect} from "react";
import MyLoaderOverlay from "../../components/LoadingOverlay";
import NoBrandsAvailable from "../../components/noBrandsAvailable/NoBrandsAvailable";
import Page500 from "../../ui-kit/src/pages/Page500";
import NoCompanySelected from "../../ui-kit/src/specialized/userForms/NoCompanySelected";
import useUserBrands from "../../common/useUserBrands";
import {handleBrandChange} from "../changeBrand";
import {LoginRequiredContainerQueryResponse} from "./__generated__/LoginRequiredContainerQuery.graphql";

type NoActiveBrandProps = {
  user: LoginRequiredContainerQueryResponse["currentUser"]
};

/**
 * Rendered when the current user has no active brand. Loads the user's brands on demand to decide
 * whether to prompt them to create a brand or to pick one of their existing brands.
 */
export default function NoActiveBrand({user}: NoActiveBrandProps) {
  const {brands, status, load} = useUserBrands();

  useEffect(() => {
    load();
  }, [load]);

  if (status === "error") {
    return <Page500/>;
  }

  if (status !== "success") {
    return <MyLoaderOverlay active={true}>{null}</MyLoaderOverlay>;
  }

  if (brands.length < 1) {
    return <NoBrandsAvailable user={user}/>;
  }

  return <NoCompanySelected
    selectText={'brand'}
    options={brands}
    onSelect={(id: string) => {
      handleBrandChange({id: id});
    }}
  />;
}
